import { render, staticRenderFns } from "./ProjectOverview.vue?vue&type=template&id=7d973f69"
import script from "./ProjectOverview.vue?vue&type=script&lang=js"
export * from "./ProjectOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports